import { Route } from "react-router-dom";

import OrderPage from "./Pages/OrderPage";
import OrderList from "./Pages/OrderList";
import Menu from "./Pages/Menu";
import Customers from "./Pages/Customers";
import Adminstration from "./Pages/Adminstration";
import Dashboard from "./Pages/Dashboard";
import Expenses from "./Pages/Expenses";
import Vendors from "./Pages/Vendors";
import Reports from "./Pages/Reports";
import Stock from "./Pages/Stock";

export const pages = [
        <Route path="/customers" element={<Customers />} />,
        <Route path="/orders" element={<OrderPage />} />,
        <Route path="/orderlist" element={<OrderList />} />,
        <Route path="/menu" element={<Menu />} />,
        // The sidebar has always carried this entry; the route it points at
        // was commented out, so clicking it landed on an empty page.
        <Route path="/adminstration" element={<Adminstration />} />,
        <Route path="/dashboard" element={<Dashboard />} />,
        // Money out, and what it adds up to. Both are the phone's screens:
        // Expenses is its expenses tab, Reports holds its income statement.
        <Route path="/expenses" element={<Expenses />} />,
        // Who the shop owes. The other half of the customers book — the
        // transactions an invoiced expense writes have always existed, this is
        // where they can finally be seen and paid down.
        <Route path="/vendors" element={<Vendors />} />,
        <Route path="/reports" element={<Reports />} />,
        // The store room. The phone shipped stock first; this is the same
        // API, entered the way a desk can: a whole invoice at a time.
        <Route path="/stock" element={<Stock />} />,
]
